import React, { useState, FC, MouseEvent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import cls from 'classnames';

import Breakpoints from 'src/explore/services/breakpoints';
import { INavItem } from 'src/prize/types/shoppe';

import { Parent } from './atoms/Parent';
import { Dropdown } from './molecules/Dropdown';

import styles from './index.module.sass';

interface IMenuProps {
  className?: {
    dropdownLink?: string;
    item?: string;
    link?: string;
  };
  data: INavItem;
  desktopBreakpoint?: 'md' | 'lg';
}

export const Menu: FC<IMenuProps> = ({ className, data, desktopBreakpoint }) => {
  const [ toggled, setToggled ] = useState( false );

  const handleClick = ( event: MouseEvent<HTMLButtonElement> ) => {
    event.preventDefault();
    event.stopPropagation();

    if ( Breakpoints.lessThan( desktopBreakpoint )) {
      setToggled(( state ) => !state );
    }
  };

  return (
    <div className={cls( styles.container, styles[`overlay-${desktopBreakpoint}`])}>
      <Parent className={className?.link} href={data.url} onClickButton={handleClick}>
        <span>{data.title}</span>

        <button
          className={cls( styles.toggle, styles[`overlay-${desktopBreakpoint}`])}
          type="button"
          onClick={handleClick}
        >
          <FontAwesomeIcon
            className={cls( styles.icon, styles[`overlay-${desktopBreakpoint}`], {
              [styles.active]: toggled,
            })}
            icon={faChevronDown}
          />
        </button>
      </Parent>

      <Dropdown
        className={{
          childLink: className?.dropdownLink,
          container: styles.dropdown,
          item: className?.item,
          link: className?.link,
        }}
        desktopBreakpoint={desktopBreakpoint}
        isExpanded={toggled}
        links={data.children}
      />
    </div>
  );
};
